import { States } from 'safe'
import {
  CLEAN_PENDING_SELLS,
  DELETE_MULTIPLE_PENDING_SELLS,
  PendingSellsTypes,
  SET_PENDING_SELLS,
} from '../actions/actionTypes'

const initialState: States.PendingSells = {
  pendingSells: [],
}

export default (
  state = initialState,
  action: PendingSellsTypes
): States.PendingSells => {
  switch (action.type) {
    case SET_PENDING_SELLS:
      return action.payload
    case CLEAN_PENDING_SELLS:
      return {
        pendingSells: [],
      }
    case DELETE_MULTIPLE_PENDING_SELLS:
      let copyValues = [...state.pendingSells]
      copyValues = copyValues.filter(
        (v) => !action.payload.some((x) => x === v.id)
      )
      return {
        ...state,
        pendingSells: copyValues,
      }
    default:
      return state
  }
}
